enum WidgetTypeEnum {
  TitleAndArrows = 'TitleAndArrows',
  BannerSlider = 'BannerSlider',
  StoreSlider = 'StoreSlider',
  FullBanner = 'FullBanner',
  DoubleBannerEqual = 'DoubleBannerEqual',
  DoubleBannerThirds = 'DoubleBannerThirds',
  TripleBannerEqual = 'TripleBannerEqual',
  InfoCardGrid = 'InfoCardGrid',
  InfoCardSlider = 'InfoCardSlider',
  BrandsSlider = 'BrandsSlider',
  StoreTabs = 'StoreTabs',
  Divider = 'Divider',
  CategoryProductSlider = 'CategoryProductSlider',
  ProductBanner = 'ProductBanner',
  ProductSlider = 'ProductSlider',
  Faq = 'Faq',
  OffersSlider = 'OffersSlider',
  ManualCategoryProductSlider = 'ManualCategoryProductSlider',
  QuoteFormBox = 'QuoteFormBox',
  FeaturedPosts = 'FeaturedPosts',
  Separator = 'Separator',
  Alert = 'Alert',
  MegamenuBanners = 'MegamenuBanners',
  BrandsGrid = 'BrandsGrid',
  PromoVideo = 'PromoVideo',
}

export default WidgetTypeEnum
